
// any CSS you import will output into a single css file (app.css in this case)
import './styles/matratzen.discount.scss';
window.gtmid = 'GTM-KSTDK4H7';
// window.fbid = '1238276627023983';
import './app'